import { Paper, Grid2 as Grid, Select, MenuItem, styled, Button, Snackbar, Alert } from "@mui/material";
import DateUtils from "../../utils/dateUtils";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FormInput from "../../components/input/form/FormInput";
import { StateAction } from "../../utils/typeAlias";
import { IPropertyGroup } from "../../models/propertyGroup";
import DateRangeSelect from "../input/date/DateRangeSelect";

const CenterGrid = styled(Grid)(() => ({
  display: "flex",
  alignItems: "center",
}));

interface SearchProps {
  propertyGroups: IPropertyGroup[];
  setPropertyGroupId: StateAction<number>;
  propertyGroupId: number;
  start: Date;
  setStart: StateAction<Date>;
  end: Date | undefined;
  setEnd: StateAction<Date | undefined>;
}

const SearchBarGlobalDashboard = ({
  start,
  setStart,
  end,
  setEnd,
  propertyGroups,
  propertyGroupId,
  setPropertyGroupId,
}: SearchProps) => {
  const { t } = useTranslation();
  const [selectedStart, setSelectedStart] = useState<Date>(start)
  const [selectedEnd, setSelectedEnd] = useState<Date | undefined>(end)
  const [selectedPGroupId, setSelectedPGroupId] = useState<number>(-1)
  const [snackbarOpen, setSnackbarOpen] = useState(false)

  useEffect(() => {
    setSelectedPGroupId(propertyGroupId)
  }, [propertyGroupId])

  useEffect(() => {
    if (selectedEnd && selectedStart > selectedEnd) {
      setSnackbarOpen(true)
    }
  }, [selectedStart, selectedEnd])

  const isInvalidRange = selectedEnd != null && selectedStart > selectedEnd;

  const onRefreshFilter = () => {
    setStart(selectedStart)
    setEnd(selectedEnd)
    setPropertyGroupId(selectedPGroupId)
  }

  return (
    <Paper elevation={1} sx={{ padding: 2 }}>
      <Grid container display={"flex"} justifyContent="space-around" gap={{ xs: 2, md: 0 }}>
        <Grid size={{ xs: 12, sm: 5, md: 4 }}>
          <DateRangeSelect
            showTime
            start={selectedStart}
            setStart={setSelectedStart}
            end={selectedEnd}
            setEnd={setSelectedEnd}
          />
        </Grid>

        <CenterGrid size={{ xs: 12, sm: 5, md: 4 }}>
          <FormInput
            sx={{ width: "100%" }}
            label={t("table.property.propertyGroups")}
          >
            <Select
              notched
              fullWidth
              defaultValue={-1}
              value={selectedPGroupId}
              onChange={(event) =>
                setSelectedPGroupId(Number(event.target.value))
              }
            >
              {propertyGroups.map((propertyGroup) => (
                <MenuItem
                  key={`propertyGroup_${propertyGroup.id}`}
                  value={propertyGroup.id}
                >
                  {propertyGroup.name}
                </MenuItem>
              ))}
            </Select>
          </FormInput>
        </CenterGrid>

        <Grid size={{ xs: 12, sm: 5, md: 2 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            color="primary"
            disabled={
              isInvalidRange ||
              (DateUtils.isSameDateTime(selectedStart, start) && DateUtils.isSameDateTime(selectedEnd, end) && selectedPGroupId === propertyGroupId)
            }
            sx={{
              marginRight: "1em",
            }}
            onClick={() => onRefreshFilter()}
          >
            {t("header.applyFilters")}
          </Button>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: "100%" }}>
          {t("header.startMustBeBeforeEnd")}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default SearchBarGlobalDashboard;
